import { BASVURU_MUELLIF_BURO_DEGISTIR } from "../constants/requestUrls";

import { postRequest } from "../request";

const basvuruMuellifBuroDegistir = (props) => {
  let data = {};
  if (props !== undefined)
    data = JSON.stringify(props);
  
  return postRequest({ url: BASVURU_MUELLIF_BURO_DEGISTIR, data });
}

export default basvuruMuellifBuroDegistir;